var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlugType1Small(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 17.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 17.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,15.5c-1.9296875,0-3.5,1.5703125-3.5,3.5s1.5703125,3.5,3.5,3.5s3.5-1.5703125,3.5-3.5S17.9296875,15.5,16,15.5z  M16,20.5c-0.8271484,0-1.5-0.6728516-1.5-1.5s0.6728516-1.5,1.5-1.5s1.5,0.6728516,1.5,1.5S16.8271484,20.5,16,20.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,10.5C24,8.5703125,22.4296875,7,20.5,7S17,8.5703125,17,10.5s1.5703125,3.5,3.5,3.5S24,12.4296875,24,10.5z M20.5,12 c-0.8271484,0-1.5-0.6728516-1.5-1.5S19.6728516,9,20.5,9S22,9.6728516,22,10.5S21.3271484,12,20.5,12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,10.5C15,8.5703125,13.4296875,7,11.5,7S8,8.5703125,8,10.5S9.5703125,14,11.5,14S15,12.4296875,15,10.5z M11.5,12 c-0.8271484,0-1.5-0.6728516-1.5-1.5S10.6728516,9,11.5,9S13,9.6728516,13,10.5S12.3271484,12,11.5,12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3339844,3.5654297c-2.9619141-2.6513672-6.9404297-3.9160156-10.9326172-3.4765625 C7.9335938,0.8066406,2.75,6.0292969,2.0771484,12.5058594C1.3779297,19.2363281,5.6044922,25.5009766,12,27.4052734V30 c0,1.1025391,0.8974609,2,2,2h4c1.1025391,0,2-0.8974609,2-2v-2.59375C25.9267578,25.6503906,30,20.2470703,30,14 C30,10.0234375,28.2998047,6.2197266,25.3339844,3.5654297z M18.7695312,25.6640625 C18.3183594,25.7714844,18,26.1738281,18,26.6376953V30h-4v-3.3623047c0-0.4638672-0.3183594-0.8662109-0.7695312-0.9726562 C7.3828125,24.28125,3.4433594,18.7128906,4.0673828,12.7128906C4.6435547,7.1650391,9.0820312,2.6914062,14.6220703,2.0771484 c0.4677734-0.0517578,0.9326172-0.078125,1.3935547-0.078125c2.9609375,0,5.7558594,1.0615234,7.9853516,3.0566406 C26.5419922,7.3310547,28,10.5908203,28,14C28,19.5820312,24.2041016,24.3789062,18.7695312,25.6640625z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugType1Small);
export default __webpack_public_path__ + "static/media/plug-type-1--small.24c1abf005faada386cb903f034e52ee.svg";
export { ForwardRef as ReactComponent };